import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { useSelectedBot } from '../contexts/SelectedBotContext.js';
import { MODE_EVENT, STUDIO_PATH } from './agentStudio/homeView';

// "Test Agent" opens the AI Studio in Test mode for the currently-selected agent:
// there every answer can be checked against what really happened (sources, tools).
// Lives in the top app bar (desktop) and inside the sidebar (mobile). Renders
// nothing when no agent is in context.
function TestAgentButton({ variant = 'header' }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { selectedBot } = useSelectedBot();

  if (!selectedBot) return null;

  const openTest = () => {
    try { localStorage.setItem(`agentStudio.mode.${selectedBot.id}`, 'test'); } catch (_) { /* storage unavailable */ }
    window.dispatchEvent(new CustomEvent(MODE_EVENT, { detail: 'test' })); // an open studio switches at once
    navigate(STUDIO_PATH);
  };

  return (
    <button
      type="button"
      className={`app-header-test-btn${variant === 'sidebar' ? ' sidebar' : ''}`}
      onClick={openTest}
    >
      <span className="app-header-test-btn-icon">
        <FontAwesomeIcon icon={faPlay} />
      </span>
      <span>{t('header_test_agent')}</span>
    </button>
  );
}

export default TestAgentButton;
